import React from "react";
import { Form } from "react-bootstrap";

const StatusFilter = ({ setBody, body, statusFilterOptionArr }) => {
  return (
    <li className="d-flex align-items-center">
      <label htmlFor="" className="form-label m-0 me-1 text-muted">
        Filter
      </label>
      <Form.Select
        aria-label="Default select example"
        className="form-control h-auto fw-sbold text-muted"
        defaultValue={body.status}
        onChange={(e) =>
          setBody((p) => ({
            ...p,
            status: e.target.value,
          }))
        }
      >
        {statusFilterOptionArr?.map((option) => (
          <option value={option.value}>{option.label}</option>
        ))}
      </Form.Select>
    </li>
  );
};

export default StatusFilter;
